<template>
<div v-if="scoreboardData">
  <!-- <div class="scoreboard scoreboard-title" style="margin-bottom: 10px;" v-if="mobile">
    {{ scoreboardData.currentDate || scoreboardData.date | date }}
  </div> -->

  <div class="scoreboard scoreboard-teams">
    <div class="team-wrapper team-wrapper-left">
      <div class="team-name" style="color: #FA3138;">Republicans</div>
      <div style="max-width: 300px; margin: 0 auto;">
        <div style="display: flex; justify-content: space-between;">
          <span class="stat-description">
            <template v-if="chartType === 'numOfSeats'">Mean Seats</template>
            <template v-else>Majority</template>
          </span>
          <span class="team-score" style="color: #FA3138; line-height: 18px;">
            <template v-if="chartType === 'seatMajority' && scoreboardData.rep">{{ (scoreboardData.rep).toFixed(1) }}%</template>
            <template v-else>{{ (scoreboardData.rep) }}</template>
          </span>
        </div>
        <div style="display: flex; justify-content: space-between;" v-if="chartType === 'seatMajority'">
          <span class="stat-description">Mean Seats</span>
          <span class="team-score secondary-score">{{ scoreboardData.seats }}</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span class="stat-description">Seat Range</span>
          <span class="team-score secondary-score">
            <template v-if="chamber === 'house' && scoreboardData.hpdGopSeats">
              {{ Object.values(scoreboardData.hpdGopSeats)[0] }} - {{ Object.values(scoreboardData.hpdGopSeats)[1] }}
            </template>
            <template v-if="chamber === 'senate' && scoreboardData.hpdGopSeats">
              {{ Object.values(scoreboardData.hpdGopSeats)[0] + 42 }} - {{ Object.values(scoreboardData.hpdGopSeats)[1] + 42 }}
            </template>
          </span>
        </div>
        <div style="display: flex; justify-content: space-between;" v-if="chartType === 'numOfSeats'">
          <span class="stat-description">Majority</span>
          <span class="team-score secondary-score">{{ scoreboardData.majority }}%</span>
        </div>
      </div>
    </div>
    <div style="min-width: 180px;" v-if="!mobile">
      <div class="scoreboard scoreboard-title" style="margin-bottom: 10px;">
        {{ scoreboardData.currentDate || scoreboardData.date | date }}
      </div>
      <div class="scoreboard scoreboard-countdown" style="margin-bottom: 10px;">
        <span class="mr-2">Days to Election:</span>
        <span style="color: #57AEA6; font-weight: 700; font-size: 1.2em;">{{ daysTillElection }}</span>
      </div>
    </div>
    <div class="team-wrapper team-wrapper-right">
      <div class="team-name" style="color: #66ABCF;">Democrats</div>
      <div style="max-width: 300px; margin: 0 auto;">
        <div style="display: flex; justify-content: space-between;">
          <div class="stat-description">
            <template v-if="chartType === 'numOfSeats'">Mean Seats</template>
            <template v-else>Majority</template>
          </div>
          <div class="team-score" style="color: #66ABCF; line-height: 18px;">
            <template v-if="chartType === 'seatMajority' && scoreboardData.dem">{{ (scoreboardData.dem).toFixed(1) }}%</template>
            <template v-else>{{ (scoreboardData.dem) }}</template>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between;" v-if="chartType === 'seatMajority'">
          <div class="stat-description">Mean Seats</div>
          <div class="team-score secondary-score">{{ scoreboardData.maxSeats - scoreboardData.seats }}</div>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <div class="stat-description">Seat Range</div>
          <div class="team-score secondary-score">
            <template v-if="chamber === 'house' && scoreboardData.hpdGopSeats">
              {{ scoreboardData.maxSeats - Object.values(scoreboardData.hpdGopSeats)[1] }} - {{ scoreboardData.maxSeats - Object.values(scoreboardData.hpdGopSeats)[0] }}
            </template>
            <template v-if="chamber === 'senate' && scoreboardData.hpdGopSeats">
              {{ scoreboardData.maxSeats - Object.values(scoreboardData.hpdGopSeats)[1] - 42 }} - {{ scoreboardData.maxSeats - Object.values(scoreboardData.hpdGopSeats)[0] - 42 }}
            </template>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between;" v-if="chartType === 'numOfSeats'">
          <div class="stat-description">Majority</div>
          <div class="team-score secondary-score">{{ (100 - scoreboardData.majority).toFixed(1) }}%</div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="scoreboard scoreboard-countdown" style="margin-bottom: 10px;" v-if="mobile">
    <span class="mr-2">Days to Election:</span>
    <span style="color: #57AEA6; font-weight: 700; font-size: 1.2em;">{{ daysTillElection }}</span>
  </div> -->
</div>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  scoreboardData: {
    type: Object,
    required: false
  },
  chartType: {
    type: String,
    required: false
  },
  chamber: {
    type: String,
    required: false
  }
}

const computed = {
  ...mapGetters({
    mobile: 'ux/mobile',
    mobilePhone: 'ux/mobilePhone'
  }),
  daysTillElection () {
    const election = new Date('2018-11-06')
    let diff = null
    if (this.mobilePhone) {
      diff = election - this.scoreboardData.date
    } else {
      const date = this.scoreboardData.currentDate ? this.scoreboardData.currentDate : this.scoreboardData.date
      if (election) {
        election.setHours(12, 0, 0, 0)
      }
      if (date) {
        date.setHours(0, 0, 0, 0)
      }
      diff = Math.round(election - date)
    }
    let days = diff / 1000 / 60 / 60 / 24
    if (days < 0) {
      days = 0
    }
    return days.toFixed(0)
  }
}

export default {
  props,
  computed
}
</script>

<style>
.scoreboard {
  display: flex;
  align-items: center;
  text-transform: uppercase;
}

.scoreboard-title {
  justify-content: center;
  font-weight: 700;
  font-size: 1.2em;
}

.team-wrapper {
  width: 50%;
  padding: 10px 30px;
}

.scoreboard-teams {
  justify-content: space-around;
  text-align: center;
  margin: 10px 0;
}

.team-name {
  letter-spacing: 0.05em;
  font-weight: 500;
  font-size: 1em;
  margin-bottom: 10px;
}

.team-score {
  font-weight: 700;
  font-size: 1.7em;
  text-align: right;
  letter-spacing: 0.05em;
}

.stat-description {
  display: flex;
  align-items: flex-end;
  text-align: left;
  padding-top: 4px;
  margin-bottom: 2px;
  font-size: 0.8em;
  text-transform: capitalize;
  color: #666;
}

.secondary-score {
  font-size: 1em;
  font-weight: 500;
  color: #555;
}

.scoreboard-countdown {
  justify-content: center;
  font-weight: 400;
  font-size: 1em;
  text-transform: none;
}

@media only screen and (max-width: 600px) {
  .team-wrapper {
    padding: 0;
  }

  .stat-description {
    font-size: 0.7em;
  }

  .team-score {
    font-size: 1.4em;
  }

  .secondary-score {
    font-size: 0.9em;
  }

  .team-wrapper-left {
    padding-right: 15px;
  }

  .team-wrapper-right {
    padding-left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Scoreboard.vue